import React from 'react';
import appStoreIcon from './Pictures/appstoreicon.png';
import googlePlayIcon from './Pictures/googleplayicon.png';
import qrCodeIcon from './Pictures/randomqr.png';
import iphoneMockup from './Pictures/iPhone14.png';

const Download = () => {
  return (
    <section id="download" className="download-section bg-black text-white text-left relative mt-12 md:h-[200px]">
      <div className="flex flex-col md:flex-row justify-between items-center px-4 md:px-24 pt-4 h-full relative z-10">
        <div className="flex flex-col w-full md:w-auto items-left md:items-start justify-center md:order-1">
          <h2 className="section-title-white text-4xl font-bold  text-center md:text-left md:text-3xl lg:text-4xl">
            <span className="block md:inline">Download</span>
            <span className="block md:inline md:ml-2">our app</span>
          </h2>
          <div className="mt-0 w-full">
            <div className="download-icons flex flex-row items-center justify-center md:justify-start gap-2 md:gap-4">
              <a href="https://www.apple.com/app-store/" target="_blank" rel="noopener noreferrer">
                <img src={appStoreIcon} alt="App Store" loading="lazy" className="app-store-icon w-20 h-20 md:w-32 md:h-28 lg:w-36 lg:h-40 mt-4 object-contain" />
              </a>
              <a href="https://play.google.com/store" target="_blank" rel="noopener noreferrer">
                <img src={googlePlayIcon} alt="Google Play" loading="lazy" className="google-play-icon w-20 h-20 md:w-32 md:h-24 lg:w-36 lg:h-40 mt-4 mr-4 object-contain" />
              </a>
              <img src={qrCodeIcon} alt="QR Code" loading="lazy" className="hidden md:block w-20 h-20 md:w-24 md:h-24 lg:w-28 lg:h-28 object-contain rounded-lg mt-4" />
            </div>
          </div>
        </div>
        {/* <div className="hidden lg:block flex-shrink-0 md:order-2 mt-8 md:mt-0 md:absolute md:right-0 md:top-0 md:translate-x-[150%] overflow-hidden">
          <img src={iphoneMockup} alt="iPhone App" loading="lazy" className="max-h-[280px] w-auto object-contain max-w-full" />
        </div> */}
      </div>
    </section>
  );
};

export default Download;
